import SPELDocument from "@/pages/Components/ViewMd";
import md from "@/assets/MDDocument/React状态管理.md";
export default function GitNode() {
  return (
    <div>
      <SPELDocument md={md} />
    </div>
  );
}
